import { Component, OnInit } from '@angular/core';
import * as emiGlobals from 'app/globals';
import { EmiBaseInfoService } from "app/shared/services/emi-base-info.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: 'emi-footer-callback-box',
  templateUrl: './emi-footer-callback-box.component.html',
  styleUrls: ['./emi-footer-callback-box.component.css']
})
export class EmiFooterCallbackBoxComponent implements OnInit {

  pageData: any = null;
  submit_form:boolean = false;
  public callBackForm: FormGroup;        
  portalInfo: any;
  menu;

  constructor(
    private baseInfoService:EmiBaseInfoService,
    private _fb: FormBuilder
  ) {
    baseInfoService.pageDataFetched$.subscribe(
      data => {
        this.getPageData();
      });
      this.getPortalInfo();
    baseInfoService.portalDataFetched$.subscribe(
    data => {
      this.getPortalInfo();
    });
  }
 getPortalInfo(){
    if(localStorage.getItem(emiGlobals.portalInfo)&&localStorage.getItem(emiGlobals.portalInfo)!='undefined'){
      this.portalInfo = JSON.parse(localStorage.getItem(emiGlobals.portalInfo));
    }
    if(localStorage.getItem(emiGlobals.portalMenu)&&localStorage.getItem(emiGlobals.portalMenu)!='undefined'){
      this.menu = JSON.parse(localStorage.getItem(emiGlobals.portalMenu));
    }
  }
  

  ngOnInit() {
    this.getPageData();
    this.callBackForm = this._fb.group({
            contact: ['',
                      [
                        Validators.pattern("[0-9]{10,10}"),
                      ]]
        });
  }

  getCallUsNumber(){
    if(this.pageData && this.pageData.call_us_number){
      return this.pageData.call_us_number;
    }
    return null;
  }

  getPageData(){
    try {
      this.pageData =JSON.parse(localStorage.getItem(emiGlobals.pageInfo));
    } catch (error) {
      console.log(error);
    }
    
  }
  saveNumber(value){
    console.log(value.contact);
    let lead ={};
    lead['contact_number'] = value.contact;
    lead['page_slug'] = this.pageData.page_slug;
    this.baseInfoService.sentLeadInformation(lead).subscribe(
        data  => {
          console.log(data);
        },
        error =>  {
          console.log(error);
        }
    );
    this.submit_form = true;
    
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/emi-footer-callback-box/emi-footer-callback-box.component.ts